<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column pr-0">
        <div class="card flex-1-auto h-100 overflow-auto">
            <div class="card-header card-header-with-button">
               <h5>{{$t('USERSUBCOMPANIES')}}</h5>
               <button
                    v-if="globals.acl.UserSubCompanies && globals.acl.UserSubCompanies.updateAction"
                    type="button"
                    class="btn-bis btn-primary"
                    @click="showModal()">
                    {{$t('NEW')}}
                </button>
            </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                        <th>{{$t('NAME')}}</th>
                        <th>{{$t('ADDRESS')}}</th>
                        <th>{{$t('POSTALCODE')}}</th>
                        <th>{{$t('CITY')}}</th>
                        <th>{{$t('CONTACTPERSON')}}</th>
                        <th>{{$t('PHONE')}}</th>
                        <th>{{$t('COUNTRY')}}</th>
                        <th>{{$t('USEREMAIL')}}</th>
                        <th v-if="hasUpdateOrDeletePermission">{{$t('ACTION')}}</th>
                    </tr>
                </thead>
                <tbody>
                  <template v-for="item in data.root">
                    <tr :key="item.subCompanyId">
                        <td>{{item.subCompanyName}}</td>
                        <td>{{item.address}}</td>
                        <td>{{item.postalCode}}</td>
                        <td>{{item.city}}</td>
                        <td>{{item.taxNumber}}</td>
                        <td>{{item.phone}}</td>
                        <td>{{item.country}}</td>
                        <td>{{item.iban}}</td>
                        <td class="table-buttons" v-if="hasUpdateOrDeletePermission">
                            <b-button
                                v-if="globals.acl.UserSubCompanies && globals.acl.UserSubCompanies.updateAction"
                                type="reset"
                                class="btn-table table-btn-tertiary"
                                v-on:click.prevent="showModal(item)">
                                {{$t('EDIT')}}
                            </b-button>
                            <b-button
                                v-if="globals.acl.UserSubCompanies && globals.acl.UserSubCompanies.deleteAction"
                                type="reset"
                                class="btn-table table-btn-delete ml-2"
                                v-on:click.prevent="deleteRow(item.subCompanyId)">
                                {{$t('DELETE')}}
                            </b-button>
                        </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <pagination
                v-bind:totalCount="data.totalCount"
                v-model="pagination">
            </pagination>
          </div>
        </div>
    </div>
    <subcompaniesform v-model="formData" v-on:close="formData = null; getData()"></subcompaniesform>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Api from '@/api/admin/UserSubCompanies'
import SubCompaniesForm from './SubCompaniesForm.vue';

export default {
    name: 'Comapnies',
    components:
    {
        subcompaniesform: SubCompaniesForm,
    },
    data()
    {
        const me = this;

        me.formDataField = {
            subCompanyName: '',
            address: '',
            city: '',
            postalCode: '',
            country: '',
            phone: '',
            taxNumber: '',
            iban: '',
        };

        return {
            loading: true,
            data: {},
            formError: {},
            formData: {...me.formDataField},
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      const data = await Api.deleteRow({ id });
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      showModal(item)
      {
          const me = this;
          if (item == null)
          {
              item = {};
          }
          me.formData = { ...item };
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      hasUpdateOrDeletePermission()
      {
        const me = this;
        if (!me.globals.acl.UserSubCompanies)
        {
            return false;
        }

        return (me.globals.acl.UserSubCompanies.updateAction || me.globals.acl.UserSubCompanies.deleteAction);
      }
  },
};
</script>
